// src/components/admin/hooks/useContentApproval.js
import { useState } from 'react';
import { ref, update } from 'firebase/database';

export function useContentApproval(db, currentUser) {
  const [approving, setApproving] = useState({});

  const handleApproveMusic = async (key) => {
    setApproving(prev => ({ ...prev, [key]: true }));
    try {
      await update(ref(db, `artistContent/music/${key}`), {
        status: 'approved',
        approvedAt: new Date().toISOString(),
        approvedByName: currentUser?.displayName || currentUser?.email || 'admin',
        approvedById: currentUser?.uid
      });
    } catch (err) {
      console.error('Error approving music:', err);
    } finally {
      setApproving(prev => ({ ...prev, [key]: false }));
    }
  };

  const handleRejectMusic = async (key, reason = '') => {
    setApproving(prev => ({ ...prev, [key]: true }));
    try {
      await update(ref(db, `artistContent/music/${key}`), {
        status: 'rejected',
        rejectedAt: new Date().toISOString(),
        rejectionReason: reason,
        rejectedByName: currentUser?.displayName || currentUser?.email || 'admin',
        rejectedById: currentUser?.uid
      });
    } catch (err) {
      console.error('Error rejecting music:', err);
    } finally {
      setApproving(prev => ({ ...prev, [key]: false }));
    }
  };

  const handleApproveVideo = async (key) => {
    setApproving(prev => ({ ...prev, [key]: true }));
    try {
      await update(ref(db, `artistContent/videos/${key}`), {
        status: 'approved',
        approvedAt: new Date().toISOString(),
        approvedBy: currentUser?.displayName || currentUser?.email || 'admin',
        approvedById: currentUser?.uid
      });
    } catch (err) {
      console.error('Error approving video:', err);
    } finally {
      setApproving(prev => ({ ...prev, [key]: false }));
    }
  };

  const handleRejectVideo = async (key, reason = '') => {
    setApproving(prev => ({ ...prev, [key]: true }));
    try {
      await update(ref(db, `artistContent/videos/${key}`), {
        status: 'rejected',
        rejectedAt: new Date().toISOString(),
        rejectionReason: reason,
        rejectedBy: currentUser?.displayName || currentUser?.email || 'admin',
        rejectedById: currentUser?.uid
      });
    } catch (err) {
      console.error('Error rejecting video:', err);
    } finally {
      setApproving(prev => ({ ...prev, [key]: false }));
    }
  };

  return {
    approving,
    handleApproveMusic,
    handleRejectMusic,
    handleApproveVideo,
    handleRejectVideo
  };
}